var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button',{style:(((_vm.right)?'float:right;':'')+';overflow:hidden'),attrs:{"disabled":_vm.disabled,"type":_vm.type,"loading":_vm.loading,"round":_vm.round,"size":_vm.size,"plain":"","icon":_vm.icon,"circle":_vm.circle},on:{"click":function($event){return _vm.go($event)}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }